import { render, staticRenderFns } from "./BookingCostSummary.vue?vue&type=template&id=5598ddcc&"
import script from "./BookingCostSummary.vue?vue&type=script&lang=js&"
export * from "./BookingCostSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports